angular.module 'zc.commonApi'

.factory "Campaign", (
  $http,
  $injector,
  $q,
  $resource,
  $translate,
  Api,
  CampaignConversionData,
  FacadeV2,
  Meta,
  MongoSession,
  Project,
  campaignServiceRequestTransformer,
  campaignServiceResponseTransformer
) ->
  Campaign = $resource Api.path("/api/projects/:projectId/campaigns/:campaignId"), { projectId: @projectId, campaignId: @id },
    get:
      method: 'GET'
      transformResponse: campaignServiceResponseTransformer
    query:
      method: 'GET'
      transformResponse: campaignServiceResponseTransformer
      isArray: false # Rails returns object instead of array
    update:
      method: 'PUT'
      transformRequest: campaignServiceRequestTransformer
      transformResponse: campaignServiceResponseTransformer
    create:
      method: 'POST'
      transformRequest: campaignServiceRequestTransformer
      transformResponse: campaignServiceResponseTransformer
    #save:
    #  transformRequest: campaignServiceRequestTransformer

  getCSVData = (conversionData, csvHeaders, fractionSize = 0) ->
    for conversion in conversionData
      for header in csvHeaders
        if header is 'created_at'
          # Although the column name on the CSV remains `created_at`, the wanted column is `conversion_at`.
          moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss')
        else if header is 'usid_overlap'
          # To preserve compatibilithy with previous implementation, output a blank string rather than outputting 0.
          conversion[header] || ''
        else if header is 'is_control'
          +conversion[header]
        else if header is 'price'
          conversion[header] / 10 ** fractionSize
        else
          conversion[header]

  getCampaignConversionData = (params) ->
    match =
      apikey: params.apikey
      campaign_id: params.campaignId
      start_at:
        $gte: moment(params.filters.start_at).toDate()
        $lt: moment(params.filters.end_at).toDate()
    match.is_control = false if params.isSecretAb
    CampaignConversionData.find { apikey: params.apikey }, { match }
    .then (conversions) ->
      if _.every(conversions, (conversion) -> _.has(conversion, 'landing_page'))
        return conversions

      chunks = _.chunk(_.map(conversions, '_usid'), 50)
      promises = _.map chunks, (chunk) ->
        return MongoSession.find
            apikey: params.apikey
            _id:
              $in: chunk
          ,
            fields: [
              'landing_page'
            ]

      $q.all promises
        .then (sessions) ->
          sessions = _.flatten(sessions)
          # Find sessions for each conversion and set sessions landing_page to conversion
          _.map conversions, (conversion) ->
            conversionSession = _.find(sessions, _id: conversion._usid)
            conversion.landing_page = _.get(conversionSession, 'landing_page') || null
            conversion

  getConversionCSVData = (params) ->
    getCampaignConversionData(params)
    .then (conversionData) ->
      csvHeaders = []
      csvHeaders.push('_uuid')
      csvHeaders.push('_usid')
      csvHeaders.push('is_control') unless params.isSecretAb
      csvHeaders.push('id')
      csvHeaders.push('price')
      csvHeaders.push('currency')
      csvHeaders.push('url')
      csvHeaders.push('landing_page')
      csvHeaders.push('created_at')
      csvHeaders.push('usid_overlap')

      for conversion in conversionData
        conversion['conversion_at_str'] = moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss')
      _.sortBy(conversionData, ['is_control', 'conversion_at_str'])
      noCvIdConversions = _.filter(conversionData, (cv) -> return cv.id == 'undefined')
      cvIdConversions = _.filter(conversionData, (cv) -> return cv.id != 'undefined')
      filteredConversionData = _.uniqBy(cvIdConversions, 'id')
      filteredConversionData = _.concat(filteredConversionData, noCvIdConversions)

      data = getCSVData(filteredConversionData, csvHeaders, params.fractionSize)
      data.unshift(csvHeaders)
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.notDisplayAb')]) unless params.isSecretAb
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.multipleCvOneSession')])
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionManagement')])
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionNotMatch')])
      return data

  service =
    getCSV: (params) ->
      if params.csvType == 'conversions'
        getConversionCSVData(params)
      else
        throw new Error("Unknown csvType: #{params.csvType}")

    # these need to be functions because of moment().toDate()
    pastCampaignFilters: () ->
      return {
        interest_widget_id: null,
        $or: [
          {
            end_at: { $lt: moment().toDate() },
            status: { $nin: ['incomplete', 'preview', 'pending'] }
          },
          {
            status: 'terminated'
          },
        ]
      }

    activeFilters: () ->
      return {
        interest_widget_id: null,
        end_at: { $gte: moment().toDate() },
        status: { $nin: ['incomplete', 'preview', 'pending', 'terminated' ] },
      }

    activeFiltersThisMonth: () ->
      return {
        interest_widget_id: null,
        end_at: { $gte: moment().startOf('month').toDate() },
        status: { $nin: ['incomplete', 'preview', 'pending', 'terminated' ] },
      }

    incompleteFilters: () ->
      return {
        interest_widget_id: null,
        status: { $in: ['incomplete'] }
      }

    isWidget: (campaign) ->
      Meta.getInterestWidgetTemplates()
      .then (templates) ->
        campaign.template_type in templates

    previewUrl: (base_url, campaign) ->
      coupon_code = ''
      if campaign.current_incentive?.incentive_type == 'unique_coupon_code'
        coupon_code = 'UNIQUE CODE'
      if campaign.current_incentive?.coupon_code?
        coupon_code = campaign.current_incentive?.coupon_code
      else if campaign.incentives[0]?.coupon_code?
        # when previewing future incentive, there might not be current
        coupon_code = campaign.incentives[0].coupon_code
      id_param = if campaign.interest_widget_id then 'zc_widget_id' else 'zc_element_id'
      base_url += if base_url.match(/\?/) then '&' else '?'
      base_url += "#{id_param}=#{campaign.element.id}&zc_control=0&zc_force_connection=1"
      base_url += "&zc_coupon_code=#{coupon_code}" if coupon_code
      base_url += '&zc_console=1' if campaign.is_widget
      base_url

    showsAllParams: (campaign) ->
      md5 = $injector.get('md5') # needed to inject in order to circumbend spec:javascript fails problem
      "zc_mmcp=#{md5.createHash(campaign.element.id.toString())}"

    showsAllUrl: (base_url, campaign) ->
      params = @showsAllParams(campaign)
      if base_url.match(/\?/)
        "#{base_url}&#{params}"
      else
        "#{base_url}?#{params}"

    adminUrl: (params, campaign) ->
      "https://zenclerk.com/admin/projects/#{params}/campaigns/#{campaign.id}/creative"

    toggleActive: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/active",
        campaign:
          state: params.state

    finish: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/finished"

    activate: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/activated"

    preview: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/preview"

    terminate: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/terminated"

    incomplete: (params) ->
      Api.patch "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/incomplete"

    copy: (params) ->
      Api.post "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/copy",
        transformResponse: campaignServiceResponseTransformer

    destroy: (params) ->
      Api.delete "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}"

    getTemplate: (params) ->
      d = $q.defer()
      Api.get("/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/template").then (res) ->
        d.resolve res.data.template
      , (err) ->
        d.reject err
      d.promise

    all: (params) ->
      d = $q.defer()
      Campaign.query(params).$promise.then (res) ->
        d.resolve res.campaigns
      , (err) ->
        d.reject err
      d.promise

    get: (params) ->
      $q (resolve, reject) ->
        Campaign.get(params).$promise.then (res) ->
          resolve res.campaign
        , (err) ->
          reject err


    update: (params, campaign) ->
      $q (resolve, reject) ->
        Campaign.update(params, campaign).$promise
        .then (res) ->
          if res.success
            resolve res
          else
            reject res

    create: (params, campaign) ->
      d = $q.defer()
      Api.post "/api/projects/#{params.projectId}/campaigns", campaign: {}
      .then (res) ->
        d.resolve res.data
      , (err) ->
        d.reject err

      d.promise

    # TODO: temporary hack for ZCS, should replace the create above
    createFromParams: (paths, params) ->
      d = $q.defer()
      Campaign.create({projectId: paths.projectId}, params).$promise
      .then (res) ->
        d.resolve res.data
      , (err) ->
        d.reject err

      d.promise


    campaignEventOrder: (params) ->
      d = $q.defer()
      Api.get "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/event_order"
      .then (res) ->
        d.resolve res.data.event_order
      , (err) ->
        d.reject err
      d.promise

    campaignEventNotices: (params) ->
      d = $q.defer()
      Api.get "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/event_notices"
      .then (res) ->
        d.resolve res.data.event_notices
      , (err) ->
        d.reject err
      d.promise

    githubUrl: (params) ->
      $q (resolve, reject) ->
        Api.get "/api/projects/#{params.projectId}/campaigns/#{params.campaignId}/github_url"
        .then (res) ->
          resolve res.data.github_url
        , (err) ->
          reject err

    publish: (params) ->
      $q (resolve, reject) ->
        FacadeV2.request "/apikeys/#{params.apikey}/campaigns/#{params.campaign_id}/publish/#{params._usid}",
          method: 'POST'
          transformResponse: $http.defaults.transformResponse
          params: params
        .then (res) ->
          unless res.data.success
            return reject res.data.error
          resolve res.data

    addCouponCode: (params) ->
      Api.post "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/add_coupon_code_to_campaign", params
      .then (res) ->
        if res.data.success
          res.data.agency
        else
          $q.reject res

    addIncentives: (params) ->
      Api.patch "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/add_incentives", params
      .then (res) ->
        if res.data.success
          res.data.incentives
        else
          $q.reject res

    canAddIncentive: (campaign) ->
      return false if campaign.current_status is 'terminated'
      return false if campaign.is_widget
      true

    hideBadgeConfigItem: (item, campaign) ->
      if item.name in ['badge_position', 'badge_icon', 'countdown_lang', 'offer_hint', 'offer_hint_display_until', 'notice', 'present_hint', 'reload_button_text'] and campaign.element.message.enables_badge == false
        return true
      false

    hideCodeLabelConfigItem: (item, campaign) ->
      if item.name in ['code_name'] and campaign.element.message.enables_code_offer_view == false
        return true
      false

  service


.factory 'campaignServiceResponseTransformer', ($filter, currencies, lib) ->
  doTransform = (campaign) ->
    try
      start_at = null
      if campaign.start_at
        start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'string', campaign.region)
      start_at = $filter('dateToDateObj')(start_at)

      end_at = null
      if campaign.end_at
        end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'string', campaign.region)
      end_at = $filter('dateToDateObj')(end_at)

      element = {}
      element.message = {}

      # These are required for campaign editor >_<
      if campaign.elements && campaign.elements.length > 0
        element.id = campaign.elements[0].id
        element.message = angular.fromJson(campaign.elements[0].message)

        # convert page types string into array
        pageTypeFields = [
          'reject_pagetypes',
          'receive_page_types',
          'ignore_pagetype',
          'limit_pagetypes',
        ]
        _.each pageTypeFields, (pageTypeField) ->
          if _.isString element.message[pageTypeField]
            element.message[pageTypeField] = lib.stringToArray(element.message[pageTypeField])

      # special handling for current status
      current_status = $filter('currentStatus')(campaign)

      if campaign.incentives
        for incentive in campaign.incentives
          incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at, 'date', campaign.region) if incentive.start_at
          incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at, 'date', campaign.region) if incentive.end_at

      campaign_obj =
        id: campaign.id
        name: campaign.name
        fee_rate: campaign.fee_rate
        fee_calculation_type: campaign.fee_calculation_type
        notes_json: campaign.notes_json
        apikey: campaign.apikey
        api_version: campaign.api_version
        currency: currencies[campaign.project_currency]
        project_id: campaign.project_id
        project_name: campaign.project_name
        memo: campaign.memo
        custom_css: campaign.custom_css
        control_percent: campaign.control_percent
        campaign_device: campaign.campaign_device
        campaign_target: campaign.campaign_target
        campaign_policy_set: campaign.campaign_policy_set
        campaign_policy_set_id: campaign.campaign_policy_set_id
        is_fired: campaign.is_fired
        clearance_item_set_id: campaign.clearance_item_set_id
        has_been_started: campaign.has_been_started
        project_base_url: campaign.project_base_url
        project_product_line: campaign.project_product_line
        project_users: campaign.project_users
        template_type: campaign.template_type
        campaign_type: campaign.campaign_type
        status: campaign.status
        days_since_last_received: campaign.days_since_last_received
        days_since_last_received_conversion: campaign.days_since_last_received_conversion
        is_information_campaign: campaign.is_information_campaign
        is_aov_campaign: campaign.is_aov_campaign
        is_secret_ab: campaign.is_secret_ab
        current_status: current_status
        region: campaign.region
        start_at: $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', campaign.region) if campaign.start_at
        end_at: $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', campaign.region) if campaign.end_at
        start_at_obj: start_at
        end_at_obj: end_at
        referrer_type: (if !campaign.referrer_type then 0 else campaign.referrer_type)
        segment: campaign.segment
        segment_id: campaign.segment_id
        exclude_logged_in: campaign.exclude_logged_in
        element: element
        incentives: campaign.incentives
        incentive_ids: _.map(campaign.incentives, 'id')
        requires_incentives: campaign.requires_incentives
        current_incentive: campaign.current_incentive
        aggregate_type: campaign.aggregate_type
        created_at: moment(campaign.created_at).tz("Asia/Tokyo").toDate()
        updated_at: moment(campaign.updated_at).tz("Asia/Tokyo").toDate()
        interest_widget_id: campaign.interest_widget_id
        is_widget: campaign.is_widget
        is_supported_by_widget: campaign.is_supported_by_widget
        is_infinite: campaign.is_infinite
        auto_restart: campaign.auto_restart
        target_conversion_name: campaign.target_conversion_name
        incentive_draft: campaign.incentive_draft
        campaign_control_percent: campaign.campaign_control_percent
        was_activated_before: campaign.was_activated_before
        cost_per_acquisition: campaign.cost_per_acquisition
        predictions_max_threshold: campaign.predictions_max_threshold
        predictions_min_threshold: campaign.predictions_min_threshold
        exclude_cart_button_click: campaign.exclude_cart_button_click
        price_min_threshold: campaign.price_min_threshold
        price_max_threshold: campaign.price_max_threshold
        exclude_no_price: campaign.exclude_no_price
        configuration_type: campaign.configuration_type
        score_threshold: campaign.score_threshold
        auto_configuration: campaign.auto_configuration
        model_names: campaign.model_names
        testing_unit: campaign.testing_unit
        ai_model_names: campaign.ai_model_names
        sampling_range: campaign.sampling_range
        sampling_score_threshold: campaign.sampling_score_threshold
        enable_botbonnie_integration: campaign.enable_botbonnie_integration
        botbonnie_trigger_rules: campaign.botbonnie_trigger_rules
        enable_botbonnie_open_chatroom: campaign.enable_botbonnie_open_chatroom

      # add campaign parameters here that need to be parsed as JSON
      _.each([
        'notes_json'
        'incentive_draft'
        'model_names'
      ], (parameter) ->
        try
          if campaign_obj[parameter]
            campaign_obj[parameter] = JSON.parse(campaign_obj[parameter])
          else
            campaign_obj[parameter] = {}
        catch err
          throw new Error('Invalid JSON value', campaign[parameter])
      )

      campaign_obj
    catch err
      {}

  return (data, headers, status) ->
    try
      data = angular.fromJson(data)
    catch
      if status == 406 and data.match(/UnknownFormat/)
        # XXX do nothing; work around our current login issue...
      else
        # Console log instead of error message
        console.log "Failed to parse campaign"
      data = {campaigns: []}

    if _.get(data, 'campaigns')
      campaigns = data.campaigns
      if _.isArray(campaigns)
        return _.assignIn data, { campaigns: _.map(campaigns, doTransform) }  if campaigns.length > 0
        return _.assignIn data, { campaigns: [] }

    else if _.get(data, 'campaign')
      obj = data.campaign
      obj.elements = data.elements
      return _.assignIn data, { campaign: doTransform(obj) }

    return _.assignIn data, { campaigns: [] }


# will be required for saving
.factory 'campaignServiceRequestTransformer', ($filter) ->
  doTransform = (elem) ->
    elem = $.extend(true, {}, elem)

    # since datetimepicker works as it works, we take values from start_at_obj
    # and end_at_obj and convert them to correct dates
    elem.start_at = $filter('dateObjToDate')(elem.start_at_obj)
    elem.start_at = $filter('changeDatetimeFrom')('localToRegion', elem.start_at, 'string', elem.region)

    elem.end_at = $filter('dateObjToDate')(elem.end_at_obj)
    elem.end_at = $filter('changeDatetimeFrom')('localToRegion', elem.end_at, 'string', elem.region)
    elem.updated_at = moment().tz("Asia/Tokyo").toDate()

    if elem.incentive_draft
      if elem.incentive_draft.is_infinite
        elem.end_at = moment('2100-12-31').toDate()

      # We need to send this as stringified json!
      elem.incentive_draft = angular.toJson(elem.incentive_draft)

    if elem.notes_json
      elem.notes_json = angular.toJson(elem.notes_json)

    if elem.elements
      elem.elements = [elem.elements[0]]
    else
      elem.elements = [elem.element]

    # convert page types array into string
    pageTypeFields = [
      'reject_pagetypes',
      'receive_page_types',
      'ignore_pagetype',
      'limit_pagetypes',
    ]

    if elem.elements[0] && elem.elements[0].message
      _.each pageTypeFields, (pageTypeField) ->
        if _.isArray elem.elements[0].message[pageTypeField]
          elem.elements[0].message[pageTypeField] = elem.elements[0].message[pageTypeField].join(',')
        else if elem.elements[0].message[pageTypeField] == null
          elem.elements[0].message[pageTypeField] = ''

    return elem

  return (data) ->
    if data.campaign
      data.campaign = doTransform(data.campaign)
    else
      data = { campaign: doTransform(data)}

    # for some reason strong parameters won't work on nested ones, so doing like this.
    data.element = data.campaign.elements[0]
    return JSON.stringify(data)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/campaign.service.js.coffee